import React from 'react';
import clsx from 'clsx';
import { Button } from 'semantic-ui-react';
import { newRequestUrl } from '@/constants/urls';
import { requestSources } from '@/requests/constants';
import DatasetStatusButton from '@/datasets/status/components/DatasetStatusButton';

const CohortStatusButtons = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  className,
  code,
  hasConditions,
  icon,
  name,
  showConditions,
  newRequestCode,
  size = 'mini',
  vertical,
}) => (
  <Button.Group
    className={clsx('aridhia-status-buttons', className)}
    vertical={vertical}
    labeled={!icon}
    size={size}
    icon
    compact
  >
    {accessRequestAllowed && (
    <DatasetStatusButton
      supported={accessRequestSupported}
      reasons={accessRequestUnsupportedReasons}
      url={newRequestUrl(requestSources.COHORT, code, newRequestCode, '#')}
      status="requestable"
      icon={icon}
    />
    )}
    {hasConditions && (
    <DatasetStatusButton
      supported
      reasons={[]}
      onClick={() => showConditions(requestSources.COHORT, code, name)}
      status="conditions"
      icon={icon}
    />
    )}
  </Button.Group>
);

export default CohortStatusButtons;
